





























import Vue from "vue";
import { Component } from "vue-property-decorator";
@Component
export default class Presenca extends Vue {
  clientes1: any = [];
  clientes2: any = [];
  clientes3: any = [];
  mounted() {
    this.clientes1 = [
      {
        title: "Centro Educacional Maria Auxiliadora - DF",
        src: require("../assets/img/clientes/CEMA.png")
      },
      {
        title: "Colégio Auxilium - GO",
        src: require("../assets/img/clientes/Auxilium.png")
      },
      {
        title: "Colégio Pio XII - MG",
        src: require("../assets/img/clientes/PioXII.png")
      },
      {
        title: "Escola Nossa Senhora Auxiliadora - MG",
        src: require("../assets/img/clientes/ENSA.png")
      },
      {
        title: "Insituto Auxiliadora - Silvânia - GO",
        src: require("../assets/img/clientes/Auxiliadora-Silvania.png")
      },
      {
        title: "Instituto Auxiliadora - São João Del Rey - MG",
        src: require("../assets/img/clientes/Auxiliadora-SJDR.png")
      },
      {
        title: "Instituto Maria Auxiliadora - GO",
        src: require("../assets/img/clientes/IMA.png")
      },
      {
        title: "Instituto Maria Imaculada - MG",
        src: require("../assets/img/clientes/IMI.png")
      },
      {
        title: "Instituto Teresa Valsé - MG",
        src: require("../assets/img/clientes/ITV.png")
      },
      {
        title: "Patronato Madre Mazzarello - GO",
        src: require("../assets/img/clientes/Patronato.png")
      },
      {
        title:
          "AMFRI - Associação dos Municipios da Região Foz do Rio Itajaí - SC",
        src: require("../assets/img/clientes/itajai.jpg")
      },
      {
        title:
          "Secretaria de Estado da Educação Cultura e Desporto de Roraima - RR",
        src: require("../assets/img/clientes/roraima.jpg")
      },
      {
        title: "Prefeitura da Cidade do Rio de Janeiro - RJ",
        src: require("../assets/img/clientes/rio.jpg")
      },
      {
        title: "Prefeitura do Jaboatão dos Guararapes - PE",
        src: require("../assets/img/clientes/jaboatao.jpg")
      },
      {
        title: "Prefeitura Municipal de Altamira - PA",
        src: require("../assets/img/clientes/altamira.jpg")
      },
      {
        title: "Prefeitura Municipal de Caruaru - PE",
        src: require("../assets/img/clientes/caruaru.jpg")
      },
      {
        title: "Prefeitura Municipal de Caxias do Sul - RS",
        src: require("../assets/img/clientes/caxiasdosul.jpg")
      },
      {
        title: "Prefeitura Municipal de Diadema - SP",
        src: require("../assets/img/clientes/diadema.jpg")
      },
      {
        title: "Prefeitura Municipal de Itajaí - SC",
        src: require("../assets/img/clientes/itajai.jpg")
      },
      {
        title: "Prefeitura Municipal de Joinville - SC",
        src: require("../assets/img/clientes/joinville.jpg")
      },
      {
        title: "Prefeitura Municipal de Manaus - AM",
        src: require("../assets/img/clientes/manaus.jpg")
      },
      {
        title: "Prefeitura Municipal de Marília - SP",
        src: require("../assets/img/clientes/marilia.jpg")
      },
      {
        title: "Prefeitura Municipal de Mossoró - RN",
        src: require("../assets/img/clientes/mossoro.jpg")
      },
      {
        title: "Prefeitura Municipal de Parnaíba - PI",
        src: require("../assets/img/clientes/parnaiba.jpg")
      },
      {
        title: "Prefeitura Municipal de Pinhais - PR",
        src: require("../assets/img/clientes/pinhais.jpg")
      },
      {
        title: "Prefeitura Municipal de Ponta Grossa - PR",
        src: require("../assets/img/clientes/pontagrossa.jpg")
      },
      {
        title: "Prefeitura Municipal de Santarém - PA",
        src: require("../assets/img/clientes/santarem.jpg")
      },
      {
        title: "Prefeitura Municipal de São José do Rio Preto - SP",
        src: require("../assets/img/clientes/saojoseriopreto.jpg")
      },
      {
        title: "Prefeitura Municipal de São José dos Pinhais - PR",
        src: require("../assets/img/clientes/saojosepinhais.jpg")
      },
      {
        title: "Prefeitura Municipal de São Mateus - ES",
        src: require("../assets/img/clientes/saomateus.jpg")
      },
      {
        title: "Prefeitura Municipal de Sao Vicente - SP",
        src: require("../assets/img/clientes/saovicente.jpg")
      },
      {
        title: "Prefeitura Municipal de Sobral - CE",
        src: require("../assets/img/clientes/sobral.jpg")
      },
      {
        title: "Prefeitura Municipal de Teresina - PI",
        src: require("../assets/img/clientes/teresina.jpg")
      },
      {
        title:
          "Serviço Apoio Micro e Pequenas Empresas de São Paulo - Sebrae - SP",
        src: require("../assets/img/clientes/sebrae.jpg")
      },
      {
        title: "Secretaria da Educação e Cultura do Estado do Piauí - PI",
        src: require("../assets/img/clientes/piaui.jpg")
      },
      {
        title: "Secretaria da Educação e Cultura do Tocantins - TO",
        src: require("../assets/img/clientes/tocantins.jpg")
      },
      {
        title: "Secretaria de Educação do Estado de Sergipe - SE",
        src: require("../assets/img/clientes/sergipe.jpg")
      },
      {
        title: "Secretaria da Educação e Cultura da Paraíba - PB",
        src: require("../assets/img/clientes/paraiba.jpg")
      },
      {
        title: "Secretaria de Educação de Mato Grosso - MT",
        src: require("../assets/img/clientes/matogrosso.jpg")
      },
      {
        title: "Secretaria de Estado da Educação do Rio Grande do Sul - RS",
        src: require("../assets/img/clientes/riograndedosul.jpg")
      },
      {
        title: "Secretaria de Estado da Educação de Rondônia - RO",
        src: require("../assets/img/clientes/rondonia.jpg")
      },
      {
        title: "Secretaria Municipal de Educação Araguaína - TO",
        src: require("../assets/img/clientes/araguaina.jpg")
      },
      {
        title: "APERAM (Cia. Aços Especiais Itabira - ACESITA) - MG",
        src: require("../assets/img/clientes/aperam.jpg")
      },
      {
        title: "Companhia de Saneamento de Minas Gerais - Copasa - MG",
        src: require("../assets/img/clientes/copasa.jpg")
      },
      {
        title: "Zurich (Companhia de Seguros Minas Brasil) - MG",
        src: require("../assets/img/clientes/zurich.jpg")
      },
      {
        title: "CONAB - Companhia Nacianal de Abastecimento - MG",
        src: require("../assets/img/clientes/conab.jpg")
      },
      {
        title:
          "Empresa da Tecnologia da Informação e Comunicação do Município de São Paulo - PRODAM-SP S/A - SP",
        src: require("../assets/img/clientes/prodam.jpg")
      },
      {
        title: "FUMSOFT Sociedade Mineira de Software - MG",
        src: require("../assets/img/clientes/fumsoft.jpg")
      },
      {
        title: "Fundação Banco do Brasil - DF",
        src: require("../assets/img/clientes/fundacao.jpg")
      },
      {
        title: "Fundação Getúlio Vargas - RJ",
        src: require("../assets/img/clientes/fgv.jpg")
      },
      {
        title: "MGS -Minas Gerais Administração e Serviços S/A - MG",
        src: require("../assets/img/clientes/mgs.jpg")
      },
      {
        title: "Ordem dos Advogados do Brasil - MG",
        src: require("../assets/img/clientes/oab.jpg")
      },
      {
        title: "Secretaria do Estado de Educação de Goiás - GO",
        src: require("../assets/img/clientes/goias.jpg")
      },
      {
        title: "SENAI - Serviço Nacional de Aprendizagem Industrial - MG",
        src: require("../assets/img/clientes/senai.jpg")
      },
      {
        title: "Toshiba do Brasil S/A - Unidade Contagem - MG",
        src: require("../assets/img/clientes/toshiba.jpg")
      },
      {
        title: "Cemig Distribuição S.A - MG",
        src: require("../assets/img/clientes/cemig.jpg")
      },
      {
        title: "Nova Era Silicon S/A - MG",
        src: require("../assets/img/clientes/novaera.jpg")
      },
      {
        title: "Rede Bandeirantes de TV - MG",
        src: require("../assets/img/clientes/band.jpg")
      }
    ];
    this.clientes2 = [
      { title: "BMS - Empresa Belgo Mineira - MG" },
      {
        title: "BEMGE - Banco do Estado de Minas Gerais S/A - MG"
      },
      {
        title: "Centro de Estudos e Pesquisas Educacionais de Minas Gerais - MG"
      },
      { title: "Colégio Pampulha - MG" },
      { title: "Colinho de Mãe e Escola Ltda - DF" },
      {
        title: "Cooperativa Central dos Produtores Rurais de Minas Gerais - MG"
      },
      {
        title: "Cooperativa Educacional de Montes Claros Ltda - COEDUCAR - MG"
      },
      { title: "ENGECON S/A - SP" },
      { title: "FUNCICI Itabira - MG" },
      {
        title: "FUNCICI - MG"
      },
      { title: "Global Site Networking Ltda - MG" },
      { title: "IFE - Instituto de Formação Empresarial - MG" },
      { title: "Instituto Educacional Monsenhor Rafael - MG" },
      { title: "Instituto Maria Montessori - MG" },
      { title: "Instituto Marista de Solidariedade - MG" },
      { title: "ITP Software do Brasil - SP" },
      { title: "M. Martins Engenharia e Comércio Ltda. - MG" },
      { title: "Minas da Serra Geral S/A - SP" },
      { title: "Nestlé Industrial e Comercial Ltda - MG" },
      { title: "Net House Informática Ltda. - MG" },
      { title: "Rede Ferroviária Federal S/A - MG" },
      { title: "SESI - Serviço Social da Industria - MG" },
      { title: "SIM - Instituto de Gestão Fiscal - MG" },
      {
        title: "Sindicato de Engenheiros no Estado de Minas Gerais - SENGE - MG"
      },
      {
        title:
          "Sindicato Estabelecimentos Particulares de Ensino do Distrito Federal - DF"
      },
      { title: "Tokarski e Cia Ltda. - MG" },
      { title: "Training Informática Ldta - RJ" },
      { title: "UBEE - União Brasileira de Educação e Ensino - MG" },
      { title: "Uniway Cooperativa de Profissionais Liberais Ltda. - RJ" },
      { title: "Prefeitura Municipal de Cruzeiro do Sul - AC" },
      { title: "Prefeitura Municipal de Coruripe - AL" },
      { title: "Prefeitura Municipal de Feliz Deserto - AL" },
      { title: "Prefeitura Municipal de Jequiá da Praia - AL" },
      { title: "Prefeitura Municipal de Murici - AL" },
      { title: "Prefeitura Municipal de Quebrangulo - AL" },
      { title: "Prefeitura Municipal de Santana do Ipanema - AL" },
      { title: "Prefeitura Municipal de Boca do Acre - AM" },
      { title: "Prefeitura Municipal de Tapauá - AM" },
      { title: "Prefeitura Municipal de Conde  - BA" },
      { title: "Prefeitura Municipal de Itapebi - BA" },
      { title: "Prefeitura Municipal de Maetinga - BA" },
      { title: "Prefeitura Municipal de Maraú - BA" },
      { title: "Prefeitura Municipal de Ourolândia - BA" },
      { title: "Prefeitura Municipal de Ribeira do Amparo - BA" },
      { title: "Prefeitura Municipal de Santa Inês - BA" },
      { title: "Prefeitura Municipal de Tremedal - BA" },
      { title: "Prefeitura Municipal de Ubatã - BA" },
      { title: "Prefeitura Municipal de Irecê - BA" },
      { title: "Prefeitura Municipal de Milagres - CE" },
      { title: "Prefeitura Municipal de Iguatu - CE" },
      { title: "Prefeitura Municipal de Aracruz - ES" },
      { title: "Prefeitura Municipal de Águas Lindas de Goiás - GO" },
      { title: "Prefeitura Municipal de Chapadão do Céu - GO" },
      { title: "Prefeitura Municipal de Itaberaí - GO" },
      { title: "Prefeitura Municipal de Rio Verde - GO" },
      { title: "Prefeitura Municipal de Bom Jesus das Selvas - MA" },
      { title: "Prefeitura Municipal de Chapadinha - MA" },
      { title: "Prefeitura Municipal de Pastos Bons - MA" },
      { title: "Prefeitura Municipal de Açailândia - MA" },
      { title: "Prefeitura Municipal de Balsas - MA" },
      { title: "Prefeitura Municipal de Codó - MA" },
      { title: "Prefeitura Municipal de Sabará - MG" },
      { title: "Prefeitura Municipal de Virginópolis - MG" },
      { title: "Escola Estadual Coronel Avelino Castelo Branco - MG" },
      { title: "Escola Estadual Professor Samuel João de Deus - MG" },
      { title: "Prefeitura Municipal de Conselheiro Pena - MG" },
      { title: "Prefeitura Municipal de Montes Claros - MG" },
      { title: "Prefeitura Municipal de Paracatu - MG" },
      { title: "Prefeitura Municipal de Rio Branco - MG" },
      { title: "Prefeitura Municipal de Cáceres - MT" },
      { title: "Prefeitura Municipal de Carlinda - MT" },
      { title: "Prefeitura Municipal de General Carneiro - MT" },
      { title: "Prefeitura Municipal de Rondonópolis - MT" },
      { title: "Prefeitura Municipal de Sinop - MT" },
      { title: "Prefeitura Municipal de Cachoeira do Piriá - PA" },
      { title: "Prefeitura Municipal de Castanhal - PA" },
      { title: "Prefeitura Municipal de Dom Eliseu - PA" },
      { title: "Prefeitura Municipal de Portel - PA" },
      { title: "Secretaria Municipal de Educação de Oeiras do Pará - PA" },
      { title: "Secretaria Municipal de Educação de Ipixuna do Pará - PA" },
      { title: "Prefeitura Municipal de Bayeux - PB" },
      { title: "Prefeitura Municipal de Cabaceiras - PB" },
      { title: "Prefeitura Municipal de Cabedelo - PB" },
      { title: "Prefeitura Municipal de Cacimba de Areia - PB" },
      { title: "Prefeitura Municipal de Conde - PB" },
      { title: "Prefeitura Municipal de Cruz do Espírito Santo - PB" },
      { title: "Prefeitura Municipal de Juarez Távora - PB" },
      { title: "Prefeitura Municipal de Juripiranga - PB" },
      { title: "Prefeitura Municipal de Lucena - PB" },
      { title: "Prefeitura Municipal de Mamanguape - PB" },
      { title: "Prefeitura Municipal de Montadas - PB" },
      { title: "Prefeitura Municipal de Mulungu - PB" },
      { title: "Prefeitura Municipal de Nova Floresta - PB" },
      { title: "Prefeitura Municipal de Pedras de Fogo - PB" },
      { title: "Prefeitura Municipal de Picuí - PB" },
      { title: "Prefeitura Municipal de Pilõezinhos - PB" },
      { title: "Prefeitura Municipal de Pocinhos - PB" },
      { title: "Prefeitura Municipal de Remígio - PB" },
      { title: "Prefeitura Municipal de Riachão do Bacamarte - PB" },
      { title: "Prefeitura Municipal de Santa Rita - PB" },
      { title: "Prefeitura Municipal de Sousa - PB" },
      { title: "Prefeitura Municipal de Araçoiaba - PE" },
      { title: "Município de Juazeiro do Piauí - PI" },
      { title: "Prefeitura Municipal de Floriano - PI" },
      { title: "Prefeitura Municipal de Água Branca - PI" },
      { title: "Prefeitura Municipal de Barras - PI" },
      { title: "Prefeitura Municipal de Batalha - PI" },
      { title: "Prefeitura Municipal de Beneditinos - PI" },
      { title: "Prefeitura Municipal de Bom Jesus - PI" },
      { title: "Prefeitura Municipal de Buriti dos Montes - PI" },
      { title: "Prefeitura Municipal de Cabeceiras do Piauí - PI" },
      { title: "Prefeitura Municipal de Castelo do Piauí - PI" },
      { title: "Prefeitura Municipal de Demerval Lobão - PI" },
      { title: "Prefeitura Municipal de Domingos Mourão - PI" },
      { title: "Prefeitura Municipal de José de Freitas - PI" },
      { title: "Prefeitura Municipal de Piripiri - PI" },
      { title: "Prefeitura Municipal de São Miguel do Tapuio - PI" },
      { title: "Secretaria Municipal de Educação de Campo Maior - PI" },
      {
        title: "Secretaria Municipal de Educação de São Miguel do Tapuio - PI"
      },
      { title: "Prefeitura Municipal de Floriano - PI" },
      { title: "Prefeitura Municipal de Campos dos Goitacazes - RJ" },
      { title: "Prefeitura Municipal de Macaé - RJ" },
      { title: "Prefeitura Municipal de Currais Novos - RN" },
      { title: "Prefeitura Municipal de Ji-Paraná - RO" },
      { title: "Prefeitura Municipal de Cacique Doble - RS" },
      { title: "Prefeitura Municipal de Campo Bom - RS" },
      { title: "Prefeitura Municipal de Caseiros - RS" },
      { title: "Prefeitura Municipal de Fagundes Varela - RS" },
      { title: "Prefeitura Municipal de Farroupilha - RS" },
      { title: "Prefeitura Municipal de Igrejinha - RS" },
      { title: "Prefeitura Municipal de Machadinho - RS" },
      { title: "Prefeitura Municipal de Marau - RS" },
      { title: "Prefeitura Municipal de Sananduva - RS" },
      { title: "Prefeitura Municipal de São Marcos - RS" },
      { title: "Prefeitura Municipal de Veranópolis - RS" },
      { title: "Prefeitura Municipal de Sapiranga - RS" },
      { title: "Prefeitura Municipal de Itabaianinha - SE" },
      { title: "Prefeitura Municipal de Lagarto - SE" },
      { title: "Prefeitura da Estância de Pereira Barreto - SP" },
      { title: "Prefeitura do Município de Jaguariúna - SP" },
      { title: "Prefeitura Municipal de Castilho - SP" },
      { title: "Prefeitura da Estância Turística de São Roque - SP" },
      { title: "Prefeitura Municipal de Guaraçaí - SP" },
      { title: "Prefeitura Municipal de Guararapes - SP" },
      { title: "Prefeitura Municipal de Guariba - SP" },
      { title: "Prefeitura Municipal de Ilha Solteira - SP" },
      { title: "Prefeitura Municipal de Nova Independência - SP" },
      { title: "Prefeitura Municipal de Porto Ferreira - SP" },
      { title: "Prefeitura Municipal de Ribeirão Pires - SP" },
      { title: "Prefeitura Municipal de Sud Mennucci - SP" },
      { title: "Prefeitura Municipal de Suzanápolis - SP" },
      { title: "Prefeitura Municipal de Valparaíso - SP" },
      { title: "Prefeitura Municipal de Araguaína - TO" },
      { title: "Prefeitura Municipal de Divinópolis do Tocantins - TO" },
      { title: "Prefeitura Municipal de Lagoa do Tocantins - TO" }
    ];
  }
}
